import type { Locale } from "@porsche-customer/slfinrtl-context-types"
import { PText } from "@porsche-design-system/components-react"
import { useCallback } from "react"
import type { MessageDescriptor } from "react-intl"
import { FormattedMessage } from "react-intl"
import { FormLayout, RadioGroup } from "src/components"
import { useLanguageOptions } from "src/hooks"

interface ExposeLanguageSelectionProps {
	onLocaleChange: (locale: Locale) => void
	selectedLocale: Locale
	subheadline: MessageDescriptor
}

export const ExposeLanguageSelection = ({
	onLocaleChange,
	selectedLocale,
	subheadline,
}: ExposeLanguageSelectionProps) => {
	const languageOptions = useLanguageOptions()

	const handleLanguageChanged = useCallback(
		(language: string) => onLocaleChange(language as Locale),
		[onLocaleChange],
	)

	return (
		<FormLayout data-testid="expose-language-selection">
			<PText data-testid="expose-language-selection-subheadline">
				<FormattedMessage {...subheadline} />
			</PText>
			<RadioGroup
				name="language"
				value={selectedLocale}
				onChange={handleLanguageChanged}
				required
				options={languageOptions}
			/>
		</FormLayout>
	)
}
